import { useQuery } from 'react-query';
import { QUERY_KEYS } from 'api/query-keys';
import { sharedCompanyService } from 'api/services';
import { GetContractorCompanyRates } from 'api/services/company/company-service.schema';

export const useGetContractorCompanyRates = () => {
  return useQuery<Promise<GetContractorCompanyRates>, Error, GetContractorCompanyRates>(
    QUERY_KEYS.contractorCompanyRates(),
    async () => sharedCompanyService.getContractorCompanyRates()
  );
};
